module.exports = __webpack_public_path__ + "media/images/favicon/favicon-05b4b384fa5f8c3411c04cec6177227c.png";